/**
 * newIndex 顶栏导航本地兜底（接口失败时使用）。
 * 线上以 GET /api/v1/portal/nav 为准，接口已包含「更多」行。
 *
 * type: anchor | route | url | more
 * names: zh / zhCHT / en / ja / ko / ru / de / ar，缺省回退 zh → en
 */
export const NEW_INDEX_NAV_SEED = [
  {
    id: 'home',
    type: 'anchor',
    value: '#home',
    more_value: '',
    visible: true,
    sort: 1,
    names: { zh: '首页', zhCHT: '首頁', en: 'Home' },
    children: [],
  },
  {
    id: 'news',
    type: 'anchor',
    value: '#latest-news',
    more_value: '',
    visible: true,
    sort: 2,
    names: { zh: '城市新闻', zhCHT: '城市新聞', en: 'City News' },
    children: [],
  },
  {
    id: 'stories',
    type: 'anchor',
    value: '#qingdao-world',
    more_value: '/active_list',
    visible: true,
    sort: 3,
    names: { zh: '青岛故事', zhCHT: '青島故事', en: 'Qingdao Stories' },
    children: [
      {
        id: 'stories-kangwan',
        type: 'route',
        value: '/active/64',
        visible: true,
        sort: 1,
        names: { zh: '中国康湾', zhCHT: '中國康灣', en: 'China Kangwan' },
      },
      {
        id: 'stories-blue',
        type: 'route',
        value: '/active/63',
        visible: true,
        sort: 2,
        names: { zh: '聚焦蓝色青岛', zhCHT: '聚焦藍色青島', en: 'Focus on Blue Qingdao' },
      },
      {
        id: 'stories-corridor',
        type: 'route',
        value: '/active/54',
        visible: true,
        sort: 3,
        names: { zh: '科创大走廊', zhCHT: '科創大走廊', en: 'Sci-Tech Innovation Corridor' },
      },
      {
        id: 'stories-happy',
        type: 'route',
        value: '/active/65',
        visible: true,
        sort: 4,
        names: { zh: '幸福青岛', zhCHT: '幸福青島', en: 'Happy Qingdao' },
      },
    ],
  },
  {
    id: 'intl',
    type: 'anchor',
    value: '#int-communication',
    more_value: '/international',
    visible: true,
    sort: 4,
    names: { zh: '国际传播', zhCHT: '國際傳播', en: 'Global Outreach' },
    children: [
      {
        id: 'intl-world-in-qd',
        type: 'route',
        value: '/international?cate_id=1',
        visible: true,
        sort: 1,
        names: { zh: '世界在青岛', zhCHT: '世界在青島', en: 'World in Qingdao' },
      },
      {
        id: 'intl-qd-in-world',
        type: 'route',
        value: '/international?cate_id=2',
        visible: true,
        sort: 2,
        names: { zh: '青岛在世界', zhCHT: '青島在世界', en: 'Qingdao in the World' },
      },
    ],
  },
  {
    id: 'gallery',
    type: 'anchor',
    value: '#photo-depot',
    more_value: '/topic_pic',
    visible: true,
    sort: 5,
    names: { zh: '青岛市图片库', zhCHT: '青島市圖片庫', en: 'Qingdao Photo Gallery' },
    children: [
      {
        id: 'gallery-exchange',
        type: 'route',
        value: '/gallery/category/2',
        visible: true,
        sort: 1,
        names: { zh: '国际交流', zhCHT: '國際交流', en: 'International Exchange' },
      },
      {
        id: 'gallery-festival',
        type: 'route',
        value: '/gallery/category/3',
        visible: true,
        sort: 2,
        names: { zh: '节会活动', zhCHT: '節會活動', en: 'Festivals & Events' },
      },
      {
        id: 'gallery-economy',
        type: 'route',
        value: '/gallery/category/7',
        visible: true,
        sort: 3,
        names: { zh: '经济发展', zhCHT: '經濟發展', en: 'Economic Development' },
      },
      {
        id: 'gallery-nature',
        type: 'route',
        value: '/gallery/category/17',
        visible: true,
        sort: 4,
        names: { zh: '自然风光', zhCHT: '自然風光', en: 'Natural Scenery' },
      },
      {
        id: 'gallery-city',
        type: 'route',
        value: '/gallery/category/21',
        visible: true,
        sort: 5,
        names: { zh: '城市风光', zhCHT: '城市風光', en: 'Cityscape' },
      },
      {
        id: 'gallery-culture',
        type: 'route',
        value: '/gallery/category/27',
        visible: true,
        sort: 6,
        names: { zh: '文化体育', zhCHT: '文化體育', en: 'Culture & Sports' },
      },
    ],
  },
  {
    id: 'collection',
    type: 'anchor',
    value: '#activities',
    more_value: '/active_list',
    visible: true,
    sort: 6,
    names: { zh: '光影征集', zhCHT: '光影徵集', en: 'Photo Collection' },
    children: [
      {
        id: 'collection-ai',
        type: 'route',
        value: '/active/82',
        visible: true,
        sort: 1,
        names: { zh: '智汇青台 ·“AI”创无限', zhCHT: '智匯青台 ·「AI」創無限', en: 'Qingtai AI Unlimited' },
      },
      {
        id: 'collection-art',
        type: 'route',
        value: '/active/81',
        visible: true,
        sort: 2,
        names: { zh: '艺绘新时代', zhCHT: '藝繪新時代', en: 'Art for a New Era' },
      },
      {
        id: 'collection-farm',
        type: 'route',
        value: '/active/80',
        visible: true,
        sort: 3,
        names: { zh: '四季农耕', zhCHT: '四季農耕', en: 'Four Seasons Farming' },
      },
    ],
  },
  {
    id: 'photographers',
    type: 'anchor',
    value: '#photographers',
    more_value: '/photo_grapher',
    visible: true,
    sort: 7,
    names: { zh: '摄影圈', zhCHT: '攝影圈', en: 'Photographers' },
    children: [
      {
        id: 'photographers-signed',
        type: 'route',
        value: '/photo_grapher',
        visible: true,
        sort: 1,
        names: { zh: '签约摄影师', zhCHT: '簽約攝影師', en: 'Contracted Photographers' },
      },
    ],
  },
  {
    id: 'vr',
    type: 'anchor',
    value: '#vr-hall',
    more_value: '/fvr',
    visible: true,
    sort: 8,
    names: { zh: 'VR展馆', zhCHT: 'VR展館', en: 'VR Gallery' },
    children: [
      {
        id: 'vr-museum-60',
        type: 'url',
        value: 'https://www.720yun.com/vr/b34jtgtfvk7',
        target: '_blank',
        visible: true,
        sort: 1,
        names: {
          zh: '青岛市博物馆建馆60周年特展',
          zhCHT: '青島市博物館建館60週年特展',
          en: 'Qingdao Museum 60th Anniversary Exhibition',
        },
      },
      {
        id: 'vr-governor',
        type: 'url',
        value: 'https://www.720yun.com/t/6avkbw2hp77?scene_id=91359007',
        target: '_blank',
        visible: true,
        sort: 2,
        names: {
          zh: '青岛德国总督楼旧址博物馆',
          zhCHT: '青島德國總督樓舊址博物館',
          en: "Former German Governor's Residence Museum",
        },
      },
      {
        id: 'vr-hill',
        type: 'url',
        value: 'https://www.720yun.com/t/ebvkul7qg79?scene_id=37594214',
        target: '_blank',
        visible: true,
        sort: 3,
        names: {
          zh: '青岛山一战遗址公园',
          zhCHT: '青島山一戰遺址公園',
          en: 'Qingdao Hill WWI Relic Park',
        },
      },
      {
        id: 'vr-chengyang',
        type: 'url',
        value: 'http://123.57.66.28:10000/',
        target: '_blank',
        visible: true,
        sort: 4,
        names: {
          zh: '青岛市城阳区博物馆',
          zhCHT: '青島市城陽區博物館',
          en: 'Chengyang District Museum',
        },
      },
      {
        id: 'vr-cpc100',
        type: 'url',
        value: 'https://www.qdpic.cn/vr/100/html/',
        target: '_blank',
        visible: true,
        sort: 5,
        names: {
          zh: '庆祝中国共产党成立100周年青岛主题展',
          zhCHT: '慶祝中國共產黨成立100週年青島主題展',
          en: 'CPC Centenary Qingdao Exhibition',
        },
      },
    ],
  },
  {
    id: 'ask',
    type: 'anchor',
    value: '#qd-service',
    more_value: '',
    visible: true,
    sort: 9,
    names: { zh: '问青岛服务平台', zhCHT: '問青島服務平台', en: 'Services Hub' },
    children: [],
  },
];
